module.exports = __webpack_public_path__ + "img/Logo_431008.2a1d73c2.jpeg";